import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, merge } from 'rxjs';
import { tap, map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { IPageDataViewModel } from '../pages/pages';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(private http: HttpClient) { }

  public getDataForView(code: string, method: string, params: any = undefined): Observable<IServiceResponse> {
    return this.getDataImpl(code, 'view', method, params);
  }

  /**
   *
   * @param method
   * @param apiPath eg... /api/SantaCruz
   * @returns
   */
  private url(method: string, apiPath: string = '/api/SantaCruz'): string {
    //console.log(`${environment.scApiProtocol}://${environment.scApiHost}:${environment.scApiPort}${apiPath}/${method}`);
    console.log(`environment.name: ${environment.name}`);
    console.log(`environment.demo: ${environment.demo}`);
    console.log(`environment.production: ${environment.production}`);
    console.log(`environment.scApiPort: ${environment.scApiPort}`);

    const ret = `${environment.scApiProtocol}://${environment.scApiHost}:${environment.scApiPort}${apiPath}/${method}`;
    return ret;
  }

  /**
   *
   * @param code
   * @param action
   * @param method
   * @param params
   * @param actionData
   * @param apiPath eg... /api/SantaCruz
   * @returns
   */
  private getDataImpl<typeOfResponse extends IServiceResponseBasic>(code: string, action: string, method: string, params: any = undefined, actionData: any = undefined, apiPath: string = '/api/SantaCruz'): Observable<typeOfResponse> {
    const request: IServiceRequest = {
      code: code,
      action: action,
      jsonActionData: JSON.stringify(actionData),
      jsonParams: JSON.stringify(params)
    };

    //console.log(method);
    //console.log(apiPath);
    console.log(this.url(method, apiPath));
    const loader$ = this.http.post<typeOfResponse>(this.url(method, apiPath), request).pipe(
      tap(v => {
        if (!v.success)
          throw v;
      }),
    );
    return loader$;
  }

  /**
   *
   * @param method
   * @param code
   * @param action
   * @param paramData
   * @param apiPath eg... /api/SantaCruz
   * @param noInit
   * @returns
   */
  public getData(method: string, code: string = '', action: string = 'view', paramData: any = undefined, apiPath: string = '/api/SantaCruz', noInit: boolean = false): Observable<IPageDataViewModel> {

    console.log('getData');
    console.log(`method: ${method}, code: ${code}, action: ${action}`);
    console.log(paramData);
    const intitial$: Observable<IPageDataViewModel> = of({
      workingText: `Executing '${method}', '${code}', '${action}'...`,
      errorText: undefined
    });
    const loader$ = this.getDataImpl(code, action, method, paramData, undefined, apiPath).pipe(
      map((v: any) => {
        const ret: IPageDataViewModel = {
          workingText: undefined,
          errorText: v.success ? undefined : v.exception ?? v.message,
          unauthorized: v.unauthorized,
          requiredGroups: v.requiredGroups,
          columns: v.columns,
          rows: v.rows,
          data: v.data,
          lastUpdated: v.lastUpdated
        };
        console.log(ret);
        return ret;
      }),
      catchError((e, v) => {
        const ret$ = of({ workingText: undefined, errorText: e.message ? e.message : e, unauthorized: e.unauthorized, notAuthenticated: e.notAuthenticated, requiredGroups: e.requiredGroups });
        console.log(`message: ${e.message}`);
        return ret$;
      })
    );
    return noInit ? loader$ : merge(intitial$, loader$);
  }
}

interface IServiceRequest {
  code: string;

  action: string;
  jsonActionData?: any;

  jsonParams?: any;
}

export interface IServiceResponseBasic {
  success: boolean;
  message: string;
  notAuthenticated?: boolean;
  lastUpdated?: Date;
}

export interface IServiceResponse extends IServiceResponseBasic {
  columns: string[];
  rows: string[][];
}

export interface IServiceDefResponse extends IServiceResponseBasic {
  code: string;
  title: string;

  defs: IServiceParamEntryItemDef[];
}

export interface IServiceParamEntryItemDef {
  code: string;
  description: string;
  helpText: string;
  required: boolean;

  entryType: string /* input, select, checkbox */
  selectItems?: { value: string, label: string }[]
  inputType?: string;
}

